import { createAction } from '@reduxjs/toolkit';
import { RescheduleEvalPayload } from './types';

export const rescheduleEval = createAction<RescheduleEvalPayload>('evaluations/rescheduleEval');
export const extendEval = createAction<RescheduleEvalPayload>('evaluations/extendEval');
